// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "linkTitle-1KcpI";
var _4 = "notesHeading-quNxF";
var _5 = "notesList-3e5bb";
var _6 = "notesListItem-1-x8v";
var _7 = "link-1xUKJ";
var _8 = "link__wrapper-1A-I4";
var _9 = "linkIcon-2FDTn";
var _a = "linkIcon_return-2cKb-";
var _b = "infoMessage-2z_fz";
var _c = "infoMessage__item-3Mytx";
var _d = "infoMessage__html-19x1h";
export { _1 as "__esModule", _2 as "tablet", _3 as "linkTitle", _4 as "notesHeading", _5 as "notesList", _6 as "notesListItem", _7 as "link", _8 as "link__wrapper", _9 as "linkIcon", _a as "linkIcon_return", _b as "infoMessage", _c as "infoMessage__item", _d as "infoMessage__html" }
export default { "__esModule": _1, "tablet": _2, "linkTitle": _3, "notesHeading": _4, "notesList": _5, "notesListItem": _6, "link": _7, "link__wrapper": _8, "linkIcon": _9, "linkIcon_return": _a, "infoMessage": _b, "infoMessage__item": _c, "infoMessage__html": _d }
